/*eslint no-unused-vars: "warn"*/
/*eslint react/prop-types: "warn"*/


import React, { useState, useRef } from 'react';
import { UseMap } from 'react-map-gl';


import {
    Alert,
    Badge,
    Card,
    Input,
    Checkbox,
    Button,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    Typography,
    IconButton,
    Tooltip,
    Select,
    Option,

} from "@material-tailwind/react";

import {
    PresentationChartBarIcon,
    ShoppingBagIcon,
    ArrowTopRightOnSquareIcon,
    MapIcon,
    ClipboardDocumentListIcon,
    UserCircleIcon,
    UsersIcon,
    Cog6ToothIcon,
    InboxIcon,
    InboxArrowDownIcon,
    PowerIcon,
    PencilIcon,
    TrashIcon,
    SparklesIcon,
    RectangleGroupIcon,
    BeakerIcon,
    FolderPlusIcon,
    //DocumentIcon,
    DocumentChartBarIcon,
    PaperClipIcon,
    FunnelIcon,
    PencilSquareIcon,

} from "@heroicons/react/24/outline";

import { FolderMinusIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Datepicker from "react-tailwindcss-datepicker";
import ConfirmDialog, { QueryDataDialog } from './ConfirmDialog.jsx';
import { showAlert } from './Alert.jsx';
import { getAnalizy, getFieldFiles } from './AdminTools.jsx';
import DocumentIcon from './DocumentIcon.jsx';
import AnalizyTableCard from './AnalizyTableCard.jsx';


export default function LabFilterCard(props) {

    const [collection, setCollection] = useState(props.labFeatures);
    const [ownerId, setOwnerId] = useState(props.ownerId);

    const [fileId, setFileId] = useState(props.fileId || 0);
    const [title, setTitle] = useState(props.title || "");
    const [labFile, setLabFile] = useState(props.labFile);

    const [files, setFiles] = useState(JSON.parse(localStorage.getItem("files")) || []);
    const [bounds, setBounds] = useState();

    const [checkedAll, setCheckedAll] = useState(true);
    const [clearOnExit, setClearOnExit] = useState(false);
    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [examDate, setExamDate] = useState(props.examDate);


    const [refreshAfterExit, setRefreshAfterExit] = useState(false);
    const [closeOnSend, setCloseOnSend] = useState(false);
    const [showConfirmClear, setShowConfirmClear] = useState(false);
    const [showAnalizyTableCard, setShowAnalizyTableCard] = useState(false);
    
    const [sendDisabled, setSendDisabled] = useState(false);
    const [labParameters, setLabParameters] = useState([]);
    const [analizy, setAnalizy] = useState(JSON.parse(localStorage.getItem("analizy")) || []);

    const unknown = useState({ id: 0, sysname: "xxx", shortname: "xxx", description: "Nieznany parametr" },);
    /*
    const analizy=[
        { labname: "any", sysName:"unknown", description: "???"},
        { labname: "Ocena_ph", sysName:"Ocena_ph", description: "Wycena Ph"},
        { labname: "ph_gleby", sysName:"ph_gleby", description: "pH gleby w KCL"},
        { labname: "Kat", sysName:"Kat", description: "Kategoria agronomiczna gleby"},
        { labname: "Ocena_p2o5", sysName: "Ocena_p2o5",  description: "Wycena P2O5"},
        { labname: "P2O5", sysName: "P2O5", description: "Tlenek fosforu"},
    ]
    */

    const emptyGeoJson = {
        "type": "FeatureCollection",
        features: []
    }



    React.useEffect(() => {
        console.log('analizy len ' + analizy.length);
        if (analizy.length == 0) getAnalizy(session, gotAnalizy);
        else { init(); }
    }, []);

    React.useEffect(() => {
        init();
    }, [analizy]);


    function compAnalizy(a, b) {
        if (a.sysname < b.sysname) {
            return -1;
        }
        if (a.sysname > b.sysname) {
            return 1;
        }
        return 0;
    }



    function gotAnalizy(anarray) {
        console.log('before');
        console.log(anarray);
        if (!anarray.some(e => e.sysname === 'xxx')) {
            console.log("doesn't contains unknown - so adding");
            //anarray.splice(0, 0, unknown); - to coś psujee
        }
        console.log('after');
        anarray.sort(compAnalizy);
        console.log(anarray);
        setAnalizy(anarray);

    }



    function init() {

        console.log("INIT");
        console.log(collection);
        console.log(analizy);

        if ((collection) && (collection.features) && (analizy.length > 0)) {

            var first = collection.features[0].properties;
            var lparams = [];
            lparams = Object.getOwnPropertyNames(first);
            var parameters = [];
            console.log('analizy at init');
            console.log(analizy);

            lparams.forEach(element => {
                var param = {};
                param.labName = element;
                param.selected = false;
                param.newName = param.labName;

                if (analizy.some((a) => a.sysname.toLowerCase() === param.labName.toLowerCase())) param.selected = true;
                /*
                param.newName = "?";
                switch (param.labName) {
                case "Ocena_ph": param.newName = param.labName; param.selected=true; break;
                case "ph_gleby": param.newName = param.labName; param.selected=true; break;
                case "Ph": param.newName = "ph_gleby"; param.selected=true; break;

                case "Ocena_p2o5": param.newName = param.labName; param.selected=true; break;
                case "P2O5": param.newName = param.labName; param.selected=true; break;

                case "Ocena_k2o": param.newName = param.labName; param.selected=true; break;
                case "K2O": param.newName = param.labName; param.selected=true; break;

                case "Ocena_mg": param.newName = param.labName; param.selected=true; break;
                case "Mg": param.newName = param.labName; param.selected=true; break;
                
                case "S": param.newName = "Siarka"; param.selected=true; break;
                case "Ca": param.newName = "Wapń"; param.selected=true; break;
                case "Cu": param.newName = "Miedź"; param.selected=true; break;
                case "Zn": param.newName = "Cynk"; param.selected=true; break;
                case "Fe": param.newName = "Żelazo"; param.selected=true; break;

                case "value": param.newName = param.labName; param.selected=true; break;
                }
                */
                parameters.push(param);
            })

            setLabParameters(parameters);
        }
    }


    function changeLabData() {

        if (!examDate) {
            showAlert("yellow", "Wybierz datę wykonania badań", 3000);
            return;
        }


        for (var i = labParameters.length - 1; i >= 0; i--) {
            if (labParameters[i].selected == false) labParameters.splice(i, 1);
        }

        console.log("parameters selected");
        console.log(labParameters);

        collection.features.forEach(feature => {
            feature.oldproperties = feature.properties;
            delete feature.properties;
            //copy parameters
            feature.properties = {};
            labParameters.forEach(param => {
                Object.defineProperty(feature.properties, param.newName, {
                    value: feature.oldproperties[param.labName],
                    writable: true,
                    enumerable: true
                });
                //feature.properties[param.newName]=feature.oldproperties[param.labName];
            });
            delete feature.oldproperties;
        });

        /*
        if (props.returnExamDate) returnExamDate(examDate);
        if (props.returnFiltered) returnFiltered(collection);
        if (props.returnTitle) returnTitle(title);
        */
        //updateLabFile();
        if (props.onFinish) props.onFinish(title, examDate, collection);

    }


    function cancelClose() {
        console.log("close on send : " + closeOnSend);

        if (props.cancel) props.cancel();
    }



    function updateLabFile() {
        setSendDisabled(true); //tymczasowo zablokuj przycisk wyślij

        collection.properties.parsed = Date.now();
        collection.properties.examDate = examDate;
        var action = "create";
        if (fileId > 0) action = "update";

        var bodydata = JSON.stringify({ action: action, session: session, id: fileId, owner: ownerId, field: 0, filename: labFile.fileName, title: title, category: "results", extension: labFile.ext, date: labFile.date, properties: JSON.stringify(collection.properties), jsondata: JSON.stringify(collection), binarydata: arrayBufferToBase64(labFile.data) });


        console.log('update lab file');
        console.log(bodydata);
        /* 
        fetch('https://online.mysoil.pl/cgi-bin/files.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleFileResponse(data))
        */
    }



    function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }




    function showParamsTableCard()
    {
        setShowAnalizyTableCard(true);
    }

    function closeParamsTableCard()
    {
        getAnalizy(session, gotAnalizy);
        setShowAnalizyTableCard(false);
    }

    //-----------------------------------------------------------------------------------------

    function SingleParameter(props) {
        const [checked, setChecked] = useState(props.selected || true);
        const [newName, setNewName] = useState(props.newName || "?");
        const [labName] = useState(props.labName);

        React.useEffect(() => {
            setChecked(props.selected);
        }, [props.selected]);


        function toggle() {
            setChecked(!checked);
            labParameters[props.index].selected = !checked;
            console.log(checked);
            if ((!checked) && (newName == "?")) changeName(props.labName);

        }

        function changeName(name) {
            setNewName(name);
            labParameters[props.index].newName = name;
        }

        function changeSelect(e) {
            console.log("change");
            console.log(e.target.value);
            if (e.target.value != "???") labParameters[props.index].newName = e.target.value;
        }


        return (
            <ListItem key={props.index} className='py-0 px-0 mx-0 text-sm' data-fieldindex={props.index} >
                <ListItemPrefix className='p-0 m-0 w-[3rem]'>
                    <Checkbox size="sm" className='m-auto p-0 w-4 h-4 rounded-md' checked={checked} onChange={toggle}></Checkbox>
                </ListItemPrefix>
                <Typography color="Black" className="mt-0 p-0 font-normal mx-auto text-left text-xs w-[5rem]">
                    {props.labName}
                </Typography>
                <ListItemSuffix className="mt-0 p-0 font-normal mx-auto text-left text-xs w-[9rem]">
                    {/*<input value={newName} onChange={e => changeName(e.target.value)} className='w-auto h-7 p-1' />*/}
                    <select size="md" variant="outlined" onChange={changeSelect} className='p-2 text-xs w-[9rem] bg-white rounded-md border border-blue-100'>
                        {analizy.map((analiza) => {
                            var lab = labName.toLowerCase();
                            var para = analiza.sysname.toLowerCase();
                            var select = false;
                            if (lab == para) select = true;
                            return (<option value={analiza.sysname} selected={select} className='text-xs'>{analiza.shortname}</option>)
                        })}
                    </select>
                </ListItemSuffix>


            </ListItem>
        )
    }

    //--------------------------------------------------------------------------------------------

    function RenderTitle(props) {
        const [myTitle, setMyTitle] = useState(props.title);


        function changeMyTitle(title) {
            setMyTitle(title);
        }

        function applyTitle() {
            console.log("my title");
            console.log(myTitle);

            setTitle(myTitle);
        }


        return (
            <div className="w-[20rem] mx-auto mt-8">
                <Input size="md" label="Tytuł pliku (opis)" className="shadow-md w-auto" value={myTitle} onChange={e => changeMyTitle(e.target.value)} onBlur={applyTitle} />
            </div>
        )
    }








    function RenderLabProperties(param) {

        return (
            labParameters.map(({ labName, newName, selected }, index) => {
                return (
                    <SingleParameter index={index} labName={labName} newName={newName} selected={selected} />
                )
            } //map
            )
        )
    }








    return (

        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[10] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-[24rem] max-w-[90vw] mx-auto rounded-lg shadow-lg max-h-[90vh] " shadow={true}>

                <div className="flex flex-col gap-2 w-auto mt-2">
                    <IconButton variant='text' className='ml-auto mr-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>

                    <Typography color="gray" className="mt-0 font-normal mx-auto">
                        Filtrowanie danych z laboratorium
                    </Typography>
                </div>
                <div className="w-auto flex flex-col gap-2 m-2">

                    <RenderTitle title={title} />


                    <div className="w-[16rem] mt-4 mx-auto">
                        <Datepicker i18n={"pl"} primaryColor="teal" asSingle={true} useRange={false} value={examDate} onChange={setExamDate} inputClassName="w-full border rounded-md shadow-md py-2.5 px-2 border-gray-400 text-gray-900 text-normal text-sm focus:border-blue-500 focus:outline-0 focus:ring-0" placeholder="Data badania" ></Datepicker>
                    </div>

                    <div id="list of lab values" className='w-[22rem] mx-auto max-h-[50vh] overflow-y-auto overflow-x-hidden border border-blue-100 rounded-lg mt-6'>

                        <List className='p-0.5 w-full'>
                            <ListItem key={0} className='p-0 mx-0 text-sm' data-fieldindex={0} >
                                <ListItemPrefix className='p-0 m-0'>
                                    <Typography color="Black" className="m-0 p-1 font-normal mx-auto text-center text-xs w-[3rem]">Import</Typography>
                                </ListItemPrefix>
                                <Typography color="Black" className="m-0 p-1 font-normal mx-auto text-left text-xs w-[5rem]">
                                    Parametr
                                </Typography>
                                <ListItemSuffix >
                                    <Typography color="Black" className="m-0 p-1 font-normal mx-auto text-left text-xs w-[9rem]">
                                        Zaimportuj jako
                                    </Typography>
                                </ListItemSuffix>
                            </ListItem>
                            <RenderLabProperties properties={labParameters} />
                        </List>


                    </div>
                    <div className="flex flex-row items center my-2 px-[1rem]">
                        <Tooltip content="Edytuj parametry analiz laboratoryjnych">
                            <IconButton variant="filled" color="blue" size="md" className='w-32 h-32' onClick={showParamsTableCard} >
                                <PencilSquareIcon className='w-5 h-5' color="white" />
                            </IconButton>
                        </Tooltip>



                        <Button className="items-center w-auto bg-gradient-to-br from-teal-500 to-cyan-500 mx-auto" disabled={sendDisabled} data-refresh={true} onClick={changeLabData}>
                            Zapisz
                        </Button>
                    </div>

                </div>
            </Card>
        {showAnalizyTableCard && <AnalizyTableCard close={closeParamsTableCard} analizy={analizy} />}
        </div>

    );

}



